(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setupBackgroundHandler();

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setupBackgroundHandler() {
      document.addEventListener('toggle', (event) => {
        const toggledDetails = event.target;
        if (toggledDetails.classList.contains('menu-drawer-container')) {
          if (toggledDetails.hasAttribute('open')) {
            this.headerWrapper.classList.add('menu-open');
          } else {
            this.headerWrapper.classList.remove('menu-open');
          }
        }
      }, true);

      document.addEventListener('toggle', (event) => {
        const toggledDetails = event.target;
        if (toggledDetails.tagName === 'DETAILS' && toggledDetails.classList.contains('mega-menu')) {
          const allMegaMenuDetails = document.querySelectorAll('.mega-menu');
          const anyMegaMenuOpen = Array.from(allMegaMenuDetails).some(detail => detail.hasAttribute('open'));
          
          if (anyMegaMenuOpen) {
            this.headerWrapper.classList.add('menu-open');
          } else {
            this.headerWrapper.classList.remove('menu-open');
          }
        }
      }, true);

      document.addEventListener('click', (event) => {
        const clickedElement = event.target.closest('summary');
        if (clickedElement && clickedElement.closest('.header__inline-menu')) {
          event.preventDefault();
          
          const targetDetails = clickedElement.parentElement;
          const mainDropdown = targetDetails.closest('.header__inline-menu > ul > li > details');
          
          const allMainDropdowns = document.querySelectorAll('.header__inline-menu > ul > li > details');
          allMainDropdowns.forEach(dropdown => {
            if (dropdown !== mainDropdown) {
              dropdown.removeAttribute('open');
              dropdown.querySelectorAll('details').forEach(sub => sub.removeAttribute('open'));
            }
          });

          if (targetDetails === mainDropdown) {
            targetDetails.toggleAttribute('open');
            if (!targetDetails.hasAttribute('open')) {
              targetDetails.querySelectorAll('details').forEach(sub => sub.removeAttribute('open'));
            }
          } else {
            const parentUl = targetDetails.closest('ul');
            const siblingDetails = parentUl.querySelectorAll('details');
            siblingDetails.forEach(detail => {
              if (detail !== targetDetails) {
                detail.removeAttribute('open');
                detail.querySelectorAll('details').forEach(sub => sub.removeAttribute('open'));
              }
            });
            targetDetails.toggleAttribute('open');
          }
        }
      });

      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          const openMegaMenus = document.querySelectorAll('.mega-menu[open]');
          openMegaMenus.forEach(menu => {
            menu.removeAttribute('open');
          });
          this.headerWrapper.classList.remove('menu-open');
          document.querySelectorAll('.header__inline-menu details[open]').forEach(dropdown => {
            dropdown.removeAttribute('open');
            dropdown.querySelectorAll('details').forEach(sub => {
              sub.removeAttribute('open');
            });
          });
        }
      });

      // เพิ่มการจัดการ disabled links
      document.querySelectorAll('.mega-menu__link[href="#"]').forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
        });
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header1"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setupBackgroundHandler();

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setupBackgroundHandler() {
      document.addEventListener('toggle', (event) => {
        const toggledDetails = event.target;
        if (toggledDetails.classList.contains('menu-drawer-container')) {
          if (toggledDetails.hasAttribute('open')) {
            this.headerWrapper.classList.add('menu-open');
          } else {
            this.headerWrapper.classList.remove('menu-open');
          }
        }
      }, true);

      document.addEventListener('toggle', (event) => {
        const toggledDetails = event.target;
        if (toggledDetails.tagName === 'DETAILS' && toggledDetails.classList.contains('mega-menu')) {
          const allMegaMenuDetails = document.querySelectorAll('.mega-menu');
          const anyMegaMenuOpen = Array.from(allMegaMenuDetails).some(detail => detail.hasAttribute('open'));
          
          if (anyMegaMenuOpen) {
            this.headerWrapper.classList.add('menu-open');
          } else {
            this.headerWrapper.classList.remove('menu-open');
          }
        }
      }, true);

      document.addEventListener('click', (event) => {
        const clickedElement = event.target.closest('summary');
        if (clickedElement && clickedElement.closest('.header__inline-menu')) {
          event.preventDefault();
          
          const targetDetails = clickedElement.parentElement;
          const mainDropdown = targetDetails.closest('.header__inline-menu > ul > li > details');
          
          const allMainDropdowns = document.querySelectorAll('.header__inline-menu > ul > li > details');
          allMainDropdowns.forEach(dropdown => {
            if (dropdown !== mainDropdown) {
              dropdown.removeAttribute('open');
              dropdown.querySelectorAll('details').forEach(sub => sub.removeAttribute('open'));
            }
          });

          if (targetDetails === mainDropdown) {
            targetDetails.toggleAttribute('open');
            if (!targetDetails.hasAttribute('open')) {
              targetDetails.querySelectorAll('details').forEach(sub => sub.removeAttribute('open'));
            }
          } else {
            const parentUl = targetDetails.closest('ul');
            const siblingDetails = parentUl.querySelectorAll('details');
            siblingDetails.forEach(detail => {
              if (detail !== targetDetails) {
                detail.removeAttribute('open');
                detail.querySelectorAll('details').forEach(sub => sub.removeAttribute('open'));
              }
            });
            targetDetails.toggleAttribute('open');
          }
        }
      });

      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
          const openMegaMenus = document.querySelectorAll('.mega-menu[open]');
          openMegaMenus.forEach(menu => {
            menu.removeAttribute('open');
          });
          this.headerWrapper.classList.remove('menu-open');
          document.querySelectorAll('.header__inline-menu details[open]').forEach(dropdown => {
            dropdown.removeAttribute('open');
            dropdown.querySelectorAll('details').forEach(sub => {
              sub.removeAttribute('open');
            });
          });
        }
      });

      // เพิ่มการจัดการ disabled links
      document.querySelectorAll('.mega-menu__link[href="#"]').forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
        });
      });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
